
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
}

export default function Card({ children, className = '', hover = false }: CardProps) {
  const hoverClasses = hover ? 'hover:-translate-y-1 hover:shadow-xl' : '';
  
  return (
    <div className={`bg-white rounded-xl lg:rounded-2xl border border-neutral-200 p-4 sm:p-6 transition-all duration-300 ${hoverClasses} ${className}`}>
      {children}
    </div>
  );
}
